module.exports = __webpack_public_path__ + "img/ky7.785f99d9.png";